import React from "react";
import AsyncComponent from "components/async-component";
import { MainProvider } from "./context/MainContext";
import { updateBreadcrumb } from "utils/breadcrumbs";
import PageContent from "components/page-content";
import PageWrap from "components/page-wrap";

class OffersAppPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <MainProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </MainProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OffersAppPage;
